import { useNavigate } from "react-router-dom";
import { BoxFiltros, ItensContainer } from "./styles";
import Table from "./Table";
import Itens from "../../assets/item-serviço.svg";
import { useAuth } from "../../providers/Auth";
import { useState } from "react";
import { ReactSVG } from "react-svg";

const ItemVitrine = () => {
  const navigate = useNavigate();
  const [perfilSelecionado, setPerfilSelecionado] = useState("");
  const [textoPesquisa, setTextoPesquisa] = useState("");

  function NovaCategoria() {
    navigate("/itemVitrine/novo");
  }

  return (
    <ItensContainer>
      <div className="box">
        <div className="flex">
          <ReactSVG src={Itens} />
          <h1>Itens Vitrine</h1>
        </div>
        <BoxFiltros>
          <div className="filtro">
            <input
              placeholder="Pesquisar por ID ou nome do item"
              value={textoPesquisa}
              onChange={(e) => setTextoPesquisa(e.target.value)}
            />
            <div>
              <p>Filtrar por status</p>
              <select
                value={perfilSelecionado}
                onChange={(e) => setPerfilSelecionado(e.target.value)}
              >
                <option value="">Ver todos</option>
                <option value={1}>ativo</option>
                <option value={0}>inativo</option>
              </select>
            </div>
          </div>
          <button onClick={NovaCategoria}>Novo Item / Serviço</button>
        </BoxFiltros>
        <Table
          perfilSelecionado={perfilSelecionado}
          textoPesquisa={textoPesquisa}
        />
      </div>
    </ItensContainer>
  );
};

export default ItemVitrine;
